import React from "react";
import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { IndianRupee } from "lucide-react";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund & Cancellation Policy" testid="refund-page" icon={IndianRupee} updated="2026">
      <LegalSection heading="Non-Refundable Fees">
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Subscription fees</strong> are non-refundable once the subscription is activated.</li>
          <li><strong>Featured listing fees</strong> are non-refundable.</li>
          <li><strong>Loan provider registration fees</strong> are non-refundable after admin approval.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Cancellation">
        <p>You may cancel your subscription at any time. Cancellation stops future renewals and billing, but does not entitle you to a refund of fees already paid for the current or previous billing periods.</p>
      </LegalSection>

      <LegalSection heading="Questions">
        <p>For any billing questions or disputes, please contact our Grievance Officer at <a href="mailto:aribina.narendra@gmail.com" className="text-brand-emerald hover:underline">aribina.narendra@gmail.com</a>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
